export const IMeta = {
  success: true,
  api_version: '1.0.0',
  front_version: '1.0.0',
  portal_version: '1.0.0',
  endpoint: '/api/v1/terminal/...',
  env: 'development',
  mode: 'development',
}
